import Vue from 'vue';
import newCampaignUrls from '../../../urls/newCampaignUrls';
import debounce from '../../../helpers/debounce';

let locationDebounceFunc = null;
let appDebounceFunc = null;

const state = {

  campaignSettings: [{name: 'New', id: 1}, {name: 'Template 1', id: 2}, {name: 'Template 2', id: 3}],

  promoteApps: [
    {
      name: 'Facebook',
      packageId: 'com.facebook.katana',
      appId: '329130',
      platform: 1
    },
    {
      name: 'Whatsapp',
      packageId: 'com.whatsapp.fsdfsdf',
      appId: '432423',
      platform: 1
    },
    {
      name: 'gsdfgfdsg',
      packageId: 'com.gsdfg.hgds',
      appId: '4234224',
      platform: 1
    },
    {
      name: 'hdggfh',
      packageId: 'com.dafsgasdfd.gfsdgdsg',
      appId: '5345356',
      platform: 2
    },
    {
      name: 'gsdfhghjfg',
      packageId: 'com.asdfasd.gd342gfds',
      appId: '476822',
      platform: 1
    },
    {
      name: 'sadfafdsaf',
      packageId: 'com.hgvccvb.fgdfgdg',
      appId: '876823',
      platform: 2
    },
    {
      name: 'sdffsdfdas',
      packageId: 'com.afsdfsa.hhgdhd',
      appId: '213753',
      platform: 1
    },
    {
      name: 'dgsgsfdg',
      packageId: 'com.adfsdf.hfghdf',
      appId: '9879783',
      platform: 2
    },
    {
      name: 'asfdsafsafsd',
      packageId: 'com.hfghf.gxdgsdfg345',
      appId: '86734532',
      platform: 1
    },
    {
      name: 'sdfgsdg',
      packageId: 'com.gsdfg.hfghfd',
      appId: '31247654',
      platform: 1
    }
  ],

  // -------- Devices --------
  devices: [{name: 'Phone', id: 1, selected: false }, {name: 'Tablet', id: 2, selected: false}],

  selectedDevices: [],
  // --------------------------

  // -------- Versions --------
  androidVersions: [
    { id: 1, name: '4.0' },
    { id: 2, name: '4.1' },
    { id: 3, name: '4.2' },
    { id: 4, name: '4.3' },
    { id: 5, name: '4.4' },
    { id: 6, name: '5.0' },
    { id: 7, name: '5.1' },
    { id: 8, name: '6.0' },
    { id: 9, name: '7.0' },
    { id: 10, name: '7.1' },
    { id: 11, name: '8.0' }
  ],

  selectedAndroidVersions: [],

  iosVersions: [
    { id: 1, name: '7.0' },
    { id: 2, name: '7.1' },
    { id: 3, name: '8.0' },
    { id: 4, name: '8.1' },
    { id: 5, name: '8.2' },
    { id: 6, name: '8.3' },
    { id: 7, name: '8.4' },
    { id: 8, name: '9.0' },
    { id: 9, name: '9.1' },
    { id: 10, name: '9.2' },
    { id: 11, name: '9.3' },
    { id: 12, name: '10.0' },
    { id: 13, name: '10.1' },
    { id: 14, name: '10.2' },
    { id: 15, name: '10.3' }
  ],

  selectedIosVersions: [],
  // --------------------------

  // -------- Locations -------
  searchingLocations: false,

  locations: [],

  initialLocations: [
    {
      id: 1,
      name: 'Asia',
      type: 1,
      showChildren: false,
      selected: false
    },
    { id: 11, parent: 1, name: 'Yemen', parentDesc: 'Asia', type: 2, selected: false },
    { id: 12, parent: 1, name: 'Iraq', parentDesc: 'Asia', type: 2, selected: false },
    { id: 13, parent: 1, name: 'Saudi Arabia', parentDesc: 'Asia', type: 2, selected: false },

    {
      id: 2,
      name: 'Europe',
      type: 1,
      showChildren: false,
      selected: false
    },
    { id: 21, parent: 2, name: 'Cyprus', parentDesc: 'Europe', type: 2, selected: false },
    { id: 22, parent: 2, name: 'Greece', parentDesc: 'Europe', type: 2, selected: false },
    { id: 23, parent: 2, name: 'Estonia', parentDesc: 'Europe', type: 2, selected: false },


    {
      id: 3,
      name: 'Africa',
      type: 1,
      showChildren: false,
      selected: false
    },
    { id: 31, parent: 3, name: 'Rwwanda', parentDesc: 'Africa', type: 2, selected: false },
    { id: 32, parent: 3, name: 'Somalia', parentDesc: 'Europe', type: 2, selected: false },
    { id: 33, parent: 3, name: 'Tanzania', parentDesc: 'Europe', type: 2, selected: false },

    {
      id: 4,
       name: 'Antartica',
      type: 1,
      showChildren: false,
      selected: false
    },
    { id: 41, parent: 4, name: 'French Southern Terr', parentDesc: 'Antarctica', type: 2, selected: false },

    {
      id: 5,
      name: 'North America',
      type: 1,
      showChildren: false,
      selected: false
    },
    { id: 51, parent: 5, name: 'Basbados', parentDesc: 'North America', type: 2, selected: false },
    { id: 52, parent: 5, name: 'Sait Pierre and Miq', parentDesc: 'North America', type: 2, selected: false },
    { id: 53, parent: 5, name: 'Greenland', parentDesc: 'North America', type: 2, selected: false },

    {
      id: 6,
      name: 'South America',
      type: 1,
      showChildren: false,
      selected: false
    },
    { id: 61, parent: 6, name: 'Guyana', parentDesc: 'North America', type: 2, selected: false },
    { id: 62, parent: 6, name: 'French Guiana', parentDesc: 'North America', type: 2, selected: false },
    { id: 63, parent: 6, name: 'Suriname', parentDesc: 'North America', type: 2, selected: false },

    {
      id: 7,
      name: 'Oceania',
      type: 1,
      showChildren: false,
      selected: false
    },
    { id: 71, parent: 7, name: 'Pala,', parentDesc: 'Oceania', type: 2, selected: false },
    { id: 72, parent: 7, name: 'Cook Islands', parentDesc: 'Oceania', type: 2, selected: false },
    { id: 73, parent: 7, name: 'East Timor', parentDesc: 'Oceania', type: 2, selected: false }
  ],

  searchLocations: [],

  locationsTree: null,

  showLocationsTree: true,
  // --------------------------

  // -------- Apps ------------
  searchingApps: false,

  apps: [],

  searchApps: []
  // --------------------------

};

const getters = {

  campaignSettings(state) {
    return state.campaignSettings;
  },

  promoteApps(state) {
    return state.promoteApps;
  },

  // -------- Devices ---------
  devices(state) {
    return state.devices;
  },

  selectedDevices(state) {
    return state.selectedDevices;
  },

  // -------- Apps ------------
  searchingApps(state) {
    return state.searchingApps;
  },

  searchApps(state) {
    return state.searchApps;
  },

  apps(state) {
    return state.apps;
  },
  // --------------------------

  // -------- Locations -------
  searchingLocations(state) {
    return state.searchingLocations;
  },

  showLocationsTree(state) {
    return state.showLocationsTree;
  },

  locations(state) {
    return state.locations;
  },

  locationsTree(state) {

    if (!state.locations || state.locations.length == 0) {
      state.locations = [];
      state.initialLocations.map((c) => {
        state.locations.push(c);
      });
    }

    if (!state.showLocationsTree) {
      return state.searchLocations;
    }

    if (state.locationsTree)
      return state.locationsTree;

    let treeify = function(list, idAttr, parentAttr, childrenAttr) {
        if (!idAttr) idAttr = 'id';
        if (!parentAttr) parentAttr = 'parent';
        if (!childrenAttr) childrenAttr = 'children';
        var treeList = [];
        var lookup = {};
        list.forEach(function(obj) {
            lookup[obj[idAttr]] = obj;
            obj[childrenAttr] = [];
        });
        list.forEach(function(obj) {
            if (obj[parentAttr] != null) {
                lookup[obj[parentAttr]][childrenAttr].push(obj);
            } else {
                treeList.push(obj);
            }
        });
        return treeList;
    };

    // build tree from the locations
    state.locationsTree = treeify(state.initialLocations);

    return state.locationsTree;

  },

  includedLocations(state) {

    let includedLocations = [];

    state.locations.map((c) => {

      if (!c.parent && c.selected) {
        includedLocations.push(c);
      }
      else if (c.parent && c.selected) {
        let parent = state.locations.find((b) => {
          return b.id == c.parent;
        });
        if (!parent.selected)
          includedLocations.push(c);
      }

    });

    return includedLocations;
    // in case location parent is included, don't add him here

  },

  excludedLocations(state) {

    let excludedLocations = [];

    state.locations.map((c) => {

      if (c.parent && !c.selected) {
        let parent = state.locations.find((b) => {
          return b.id == c.parent;
        });

        let selectedChildren = state.locations.filter((b) => {
          return b.parent == parent.id && b.selected;
        });

        if (parent.selected && selectedChildren.length > 0)
          excludedLocations.push(c);
      }

    });

    return excludedLocations;
    // in case location parent is not included, add him here

  },
  // --------------------------

  // -------- Versions --------
  selectedAndroidVersions(state) {
    return state.selectedAndroidVersions;
  },

  androidVersions(state) {
    return state.androidVersions;
  },

  iosVersions(state) {
    return state.iosVersions;
  }
  // --------------------------

};

const mutations = {

  // -------- Devices ---------
  setSelectedDevices(state, devices) {
    state.selectedDevices = devices;
  },

  // -------- Versions --------
  setSelectedAndroidVersions(state, payload) {
    state.selectedAndroidVersions = payload;
  },

  removeAndroidVersions(state, payload) {
    let index = state.selectedAndroidVersions.findIndex((c) => {
      return c == payload;
    });
    state.selectedAndroidVersions.splice(index, 1);
  },
  // --------------------------

  // -------- Locations -------
  selectLocation(state, item) {

    if (!item.parent) {

      let children = state.locations.map((c) => {
        if (c.parent == item.id)
          c.selected = item.selected;
      });

    }
    else {

      let parent = state.locations.find((c) => {
        return c.id == item.parent;
      });

      let children = state.locations.filter((c) => {
        return c.parent == parent.id;
      });
      let selectedChildren = children.filter((c) => {
        return c.selected;
      });

      if (selectedChildren.length == children.length) {
        parent.selected = true;
      }
      else if (selectedChildren.length == 0) {
        parent.selected = false;
      }

    }

  },

  searchLocation(state, payload) {

    if (locationDebounceFunc) {
      locationDebounceFunc(payload);
      return;
    }

    locationDebounceFunc = debounce((searchString) => {

      state.searchingLocations = true;

      Vue.$http.post(newCampaignUrls.getLocations, searchString).then((response) => {
        const data = response.data;
        if (!data || data.length == 0) {
          //store.commit('clearLocationsSearch');
          return;
        }

        let arr = [];

        data.map((c) => {

          let location = state.locations.find((b) => {
            return c.id == b.id;
          });

          if (!location) {
            state.locations.push(c);
            location = c;
          }

          arr.push(location);

        });

        state.searchLocations = arr;
        state.searchingLocations = false;
        state.showLocationsTree = false;

      }).catch((error) => {

        //store.commit('clearLocationsSearch');

      });

    });

    locationDebounceFunc(payload);

  },

  clearLocationsSearch() {

    state.searchingLocations = false;
    state.showLocationsTree = true;

  },
  // --------------------------

  // -------- Apps ------------
  selectApp(state, payload) {

    let app = state.apps.find((c) => {
      return c.id == payload.id;
    });

    if (!app) {
      state.apps.push(payload);

      let appIndex = state.searchApps.findIndex((c) => {
        return c.id == payload.id;
      });
      state.searchApps.splice(appIndex, 1);
    }

  },

  searchApp(state, payload) {

    if (appDebounceFunc) {
      appDebounceFunc(payload);
      return;
    }

    appDebounceFunc = debounce((searchString) => {

      state.searchingApps = true;

      Vue.$http.post(newCampaignUrls.getApps, searchString).then((response) => {
        const data = response.data;
        if (!data || data.length == 0) {
          //store.commit('clearAppSearch');
          return;
        }

        let arr = [];
        data.map((c) => {
          let app = state.apps.find((b) => {
            return c.id == b.id;
          });
          if (!app)
            arr.push(c);
        });

        state.searchApps = arr;
        state.searchingApps = false;

      }).catch((error) => {

        //store.commit('clearAppSearch');

      });

    });

    appDebounceFunc(payload);

  },

  clearAppSearch(state, payload) {

    state.searchingApps = false;
    state.searchApps = [];

  },

  removeApp(state, payload) {

    let appIndex = state.apps.findIndex((c) => {
      return c.id == payload.id;
    });

    if (appIndex != -1) {
      state.apps.splice(appIndex, 1);
    }

  },

  selectAllApps(state, payload) {

    state.searchApps.map((c) => {
      let app = state.apps.find((b) => {
        return c.id == b.id;
      });
      if (!app) {
        state.apps.push(c);
      }
      state.searchApps = [];
    });

  }
  // --------------------------

};

const actions = {

  // -------- Locations -------
  searchLocation(context, payload) {
    context.commit('searchLocation', payload);
  },
  // --------------------------

  // -------- Apps ------------
  searchApp(context, payload) {
    context.commit('searchApp', payload);
  },
  // --------------------------

  fetchCampaignDetails(context, payload) {

    return new Promise((resolve, reject) => {

      let getCampaignDetailsUrl = newCampaignUrls.getCampaignDetails;
      // in case we're in edit mode, we also send the campaignId to the server in the query string
      if (payload && payload.campaignId && payload.campaignId != '')
          getCampaignDetailsUrl += `?campaignId=${payload.campaignId}`;

      Vue.$http.get(getCampaignDetailsUrl).then((response) => {

        resolve(response.data);

      }).catch((error) => {

        reject();

      });

    });

  }

};

export default {
  state,
  getters,
  mutations,
  actions
};



// WEBPACK FOOTER //
// ./src/components/Campaign/store/Campaign.js